
/* eslint-disable max-len */
const Facilities = () => (
  <svg id="Art" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2">
    <line x1="12" y1="3" x2="12" y2="21" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="14" y1="21" x2="10" y2="21" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <polyline points="12 5 18 5 21 7.5 18 10 6 10 3 12.5 6 15 12 15" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Facilities;
